import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { 
	withStyles,
	Button,
	Grid,
	IconButton,
	Dialog,
	DialogTitle,
	DialogContent,
	Link,
	Typography,
	MenuItem,
	FormLabel,
	FormHelperText
} from '@material-ui/core';
import classNames from 'classnames';
import ValidationSchema from './ContactSalesSchema';
import { isChrome } from '../../utils/browser';
import { hideModal, resetModal } from 'redux/modules/modal';
import { sendContactSalesRequest } from 'redux/modules/companies';
import { Select } from '../../components/Features/components';
import SelectArrow from '@material-ui/icons/KeyboardArrowDown';
import PropTypes from 'prop-types';
import FormField from '../FormField';
import { XIcon, SpinnerIcon } from '../../theme/icons';
import _ from 'lodash';
import ERRORS from '../../errors/errorids';
import { trackContactSalesPopupShown } from 'lib/Segment/customTrackers';
import { CONTACT_SALES } from '../../config';
import { getTrackingOptions } from 'lib/Segment/helpers';

import i18n from 'i18n/i18n';
const localize = i18n.loc.localize;

let detectErrorsInFormFields = 
	['firstName', 'lastName', 'companyName', 'nrOfUsers', 'workEmail', 'jobTitle', 'usageInfo'];

const errors = {
	[ERRORS.OFFLINE]: localize('contact-sales-error-offline')
};

const NR_OF_USERS_OPTIONS = ['20-49', '50-99', '100-250', '251-500', '501-1000', '1000+'];

const styles = theme => {
	return {
		/* Dialog */
		dialogPaper: {
			minWidth: 444
		},
		dialogWrapper: {
			position: 'relative',
			padding: '15px 10px 0',
			minHeight: 291
		},
		dialogTitle: {
			'& h6': {
				fontWeight: 600,
				fontSize: '28px',
				lineHeight: 1.2,
				marginBottom: 20,
				textAlign: 'left'
			}
		},
		/* dialog content */
		dialogContent: {
			overflow: 'visible'
		},
		/* close button */
		closeDialog: {
			position: 'absolute',
			top: 10,
			right: 10
		},
		closeDialogIcon: {
			color: '#6F99BD',
			width: '20px',
			height: '20px'
		},
		/* form */
		formRow: {
			justifyContent: 'space-between',
			marginBottom: 10
		},
		formField: {
			flex: '0 0 45%',
			margin: '0 0 10px'
		},
		formLabel: {
			display: 'block',
			textAlign: 'left',
			fontWeight: 600,
			lineHeight: 1.5,
			opacity: 1,
			color: '#000000bf',
			margin: '0 0 5px'
		},

		/* loading icon */
		loadingContainer: {
			minHeight: 402,
			position: 'relative'
		},
		loadingContent: {
			position: 'absolute',
			top: '50%',
			left: '50%',
			transform: 'translate(-50%, -50%)'
		},
		loadingMessage: {
			fontSize: 16,
			lineHeight: 1.5,
			opacity: 1
		},
		loadingIcon: {
			display: 'block',
			height: '24px',
			width: '24px',
			margin: '0 auto 10px',
			fill: '#96DCFD',
			animation: 'spin 2s linear infinite'
		},
		'@keyframes spin': {
			'0': {
				transform: 'rotate(0deg)'
			},
			'100%': {
				transform: 'rotate(360deg)'
			}
		},

		/* input field */
		fieldTextElement: {
			width: '100%',
			margin: 0,
			'&.noLabel': {
				marginTop: 29
			},

			'& input, & textarea': {
				border: '1px solid #aabfd1',
				borderStyle: 'solid',
				borderRadius: 5,
				color: theme.palette.text.primary,
				padding: '10px',
				'&:focus, &:hover': {
					color:'#2888c3',
					borderColor:'#2888c3'
				},

				'&::placeholder': {
					fontFamily: 'Open Sans, sans-serif',
					fontWeight: 'normal',
					fontStyle: 'normal',
					fontSize: '14px',
					lineHeight: '19px',
					color: theme.palette.text.primary
				}
			},

			'& textarea': {
				width: '425px',
				display: 'block',
			},

			'& [id*=helper-text]': {
				paddingLeft: 0,
				color: theme.palette.error.main
			},

			'& [class*=error] input': {
				borderColor: `${theme.palette.error.main} !important`
			}
		},		

		fieldSelectElement: {
			width: '100%'
		},
		selectElement: {
			borderRadius: 5,
			boxShadow: 'none',
			borderColor: '#aabfd1',
			padding: 10,
			textAlign: 'left',
			'&:hover, &:focus': {
				borderRadius: 5,
				color:'#2888c3',
				borderColor:'#2888c3'
			}
		},
		selectElementError: {
			borderRadius: 5,
			boxShadow: 'none',
			borderColor: `${theme.palette.error.main} !important`,
			padding: 10,
			textAlign: 'left',
			'&:hover, &:focus': {
				borderRadius: 5,
				color:'#2888c3',
				borderColor:'#2888c3'
			}
		},
		selectElementItem: {
			'&:hover': {
				background: '#e0f5fe'
			},
			'&[class*=selected]': {
				background: '#e0f5fe !important'
			}
		},
		selectElementIcon: {
			right: 4,
			'&:hover': {
				color:'#93c3e1'
			}			
		},
		selectElementPaper: {
			borderRadius: 5,
			border: 0,
			boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
		},
		selectError: {
			paddingLeft: 0,
			color: theme.palette.error.main,
			fontStyle: 'italic'
		},
		
		/* buttons */
		actionButtons: {
			justifyContent: 'space-between',
			padding: '10px 0 20px'
		},
		
		actionButtonSubmitColumn: {
		},
		
		actionButtonDemoLinkColumn: {
			display: 'flex',
			alignItems: 'center'
		},
		
		demoLink: {
			textDecoration: 'underline',
			textTransform: 'uppercase',
			'&:hover': {
				textDecoration: 'none',
			},
			fontSize: 13,
			lineHeight: 1.2,
			opacity: 1,
			'html[lang="de"] &': {
				maxWidth: 200
			}
		},

		button: {
			fontFamily: 'Open Sans, sans-serif',
			borderRadius: 5,
			fontWeight: 600,
			fontSize: 18,
			lineHeight: 1.3,
			opacity: '1 !important'
		},
		buttonPrimary: {
			background: theme.palette.primary.main,
			color: 'white',
			textShadow: 'none',
			paddingLeft: 10,
			paddingRight: 10,
			width: '100%',
			'&[class*=contained][class*=disabled]': {
				backgroundColor: '#f4f4f4',
				color: '#4a5660'
			}
		},
		buttonClose: {
			display: 'block',
			maxWidth: 200,
			margin: '0 auto'
		},

		/* error message */
		errorMessage:  {
			color: theme.palette.error.main,
			fontSize: 14,
			lineHeight: 1.5,
			opacity: 1,
			textAlign: 'left',
			marginTop: -15,
			marginBottom: 15,
			'& a': {
				color: theme.palette.primary.main
			}
		},

		/* success message */
		successMessage: {
			textAlign: 'left',
			color: '#000',
			fontSize: 14,
			lineHeight: 1.3,
			opacity: 1,
			padding: '0 0 30px',
			'& a': {
				color: '#2fa5e7'
			}
		}
	};
};

@withStyles(styles)
class ContactSalesModal extends Component {

	constructor(props) {
		super(props);

		this.state = {
			values: {
				firstName: '',
				lastName: '',
				companyName: '',
				nrOfUsers: '',
				workEmail: '',
				jobTitle: '',
				phoneNumberPrefix: '',
				phoneNumber: '',
				usageInfo: ''
			},

			xhrInProgress: false,
			apiRequestSuccess: false,
			apiRequestError: false,
			errors: {},
			touched: {}
		};

		this.scrollbarRef = React.createRef(null);
	}

	render() {
		const { modalShown, resetModal, classes } = this.props;

		return (
			<Dialog
				open={modalShown}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				onExited={resetModal}
				BackdropProps={{ style: { backgroundColor: 'rgba(46, 63, 79, 0.4)' } }}
				classes={{ paper: classes.dialogPaper }}
				PaperProps={{
					style: {
						border: 0,
						width: 309,
						minWidth: 505,
						borderRadius: 5,
						boxShadow: '0px 4px 24px rgba(0, 0, 0, 0.08)'
					}
				}}
			>
				<div className={classes.dialogWrapper}>
					{!this.state.xhrInProgress && (
						<IconButton
							className={classes.closeDialog}
							component='span'
							aria-label='Close'
							onClick={() => this.closeDialog()}
						>
							<XIcon className={classes.closeDialogIcon} />
						</IconButton>
					)}
					
					{(() => {
						if (this.state.xhrInProgress) {
							return this.renderLoading();
						} else if (this.state.apiRequestSuccess) {
							return this.renderSuccess();
						} else if (this.state.apiRequestError) {
							return this.renderForm();
						} else {
							return this.renderForm();
						}
					})()}
				</div>
			</Dialog>
		);
	}

	closeDialog() {
		this.props.hideModal();
	}

	renderLoading() {
		const { classes } = this.props;
		return (
			<div className={classes.loadingContainer}>
				<div className={classes.loadingContent}>
					<SpinnerIcon className={classes.loadingIcon} />
					<Typography className={classes.loadingMessage} variant="body2">
						{localize('contact-sales-saving-form')}
					</Typography>
				</div>
			</div>
		);
	}

	renderErrorMessage() {
		const errors = this.state.errors;
		const apiError = _.get(errors, 'apiError');
		const formError = this.hasFormError(errors) && localize('contact-sales-please-errors-found-in-the-form');
		
		let errorMessage;
		if (formError) {
			errorMessage = formError;
		} else if (apiError) {
			errorMessage = apiError;
		}

		const { classes } = this.props;
		return (
			<Typography className={classes.errorMessage} variant="body2" dangerouslySetInnerHTML={{ __html: errorMessage }} />
		);		
	}

	renderSuccess() {
		const { classes } = this.props;

		return (
			<Fragment>
				<DialogTitle
					variant='body1'
					color='default'
					className={classes.dialogTitle}>{localize('contact-sales-form-success-title')}
				</DialogTitle>
				<DialogContent className={classes.dialogContent} >
					<Typography
						className={classes.successMessage}
						variant="body2"
						onClick={() => this.openCalendlyLink()}
						dangerouslySetInnerHTML={{ __html: 
								localize('contact-sales-form-success-description')
						}} />
					<Button
						variant='contained'
						key='main'
						className={classNames(classes.button, classes.buttonPrimary, classes.buttonClose)}
						onClick={() => this.closeDialog()}
					>
						{localize('close')}
					</Button>				
				</DialogContent>
			</Fragment>
		);
	}

	renderForm() {
		const { classes } = this.props;

		return (
			<Fragment>
				<DialogTitle
					variant='body1'
					color='default'
					className={classes.dialogTitle}>{this.props.title}
				</DialogTitle>
				<DialogContent className={classes.dialogContent} >
					<Grid container direction="column">
						{Object.keys(this.state.errors).length > 0 && this.renderErrorMessage()}
						<Grid container item direction="column" className={classes.userRowsContainer}>
							{this.renderFormFields()}
						</Grid>
						<Grid item container direction="row" justify="flex-end" className={classes.actionButtons}>
							<Grid item className={classes.actionButtonSubmitColumn}>
								<Button
									variant='contained'
									color='primary'
									data-tid="button-contact-sales"
									className={classNames(classes.button, classes.buttonPrimary)}
									onClick={() => this.submitForm()}
									disabled={!this.isSubmitEnabled()}>
									{localize('contact-sales-form-submit')}
								</Button>
							</Grid>
							<Grid item className={classes.actionButtonDemoLinkColumn}>
								<Link 
									variant='body1'
									onClick={() => this.openCalendlyLink()}
									className={classes.demoLink}
									underline="none">
									{localize('contact-sales-form-demo-link')}
								</Link>							
							</Grid>
						</Grid>
					</Grid>
				</DialogContent>
			</Fragment>
		);
	}

	openCalendlyLink() {
		const newWindow = window.open(CONTACT_SALES.CALENDLY_LINK, '_blank');
		newWindow && newWindow.focus();							
	}

	renderFormFields() {
		const { classes } = this.props;
		return (
			<Fragment>
				<Grid container item direction="row" className={classes.formRow}>
					<Grid item className={classes.formField}>
						{
							this.textField(
								'firstName',
								this.state.values.firstName,
								localize('contact-sales-form-first-name'),
								false,
								'text'
							)
						}
					</Grid>
					<Grid item className={classes.formField}>
						{
							this.textField(
								'lastName',
								this.state.values.lastName,
								localize('contact-sales-form-last-name'),
								false,
								'text'
							)
						}
					</Grid>
				</Grid>
				<Grid container item direction="row" className={classes.formRow}>
					<Grid item className={classes.formField}>
						{
							this.textField(
								'companyName',
								this.state.values.companyName,
								localize('contact-sales-form-company-name'),
								false,
								'text')
						}
					</Grid>
					<Grid item className={classes.formField}>
						{
							this.selectField(
								'nrOfUsers',
								this.state.values.nrOfUsers,
								localize('contact-sales-form-number-of-users'),
								true
							)
						}
					</Grid>
				</Grid>
				<Grid container item direction="row" className={classes.formRow}>
					<Grid item className={classes.formField}>
						{
							this.textField(
								'workEmail',
								this.state.values.workEmail,
								localize('contact-sales-form-work-email'),
								false,
								'email')
						}
					</Grid>
					<Grid item className={classes.formField}>
						{
							this.textField(
								'jobTitle',
								this.state.values.jobTitle,
								localize('contact-sales-form-job-title'),
								false,
								'text'
							)
						}
					</Grid>
				</Grid>			
				<Grid container item direction="row" className={classes.formRow}>
					<Grid item className={classes.formField}>
						{
							this.selectField(
								'phoneNumberPrefix',
								this.state.values.phoneNumberPrefix,
								localize('contact-sales-form-phone-number'),
								false
							)
						}
					</Grid>
					<Grid item className={classes.formField}>
						{
							this.textField(
								'phoneNumber',
								this.state.values.phoneNumber,
								localize('contact-sales-form-phone-number'),
								false,
								'text',
								null,
								null,
								'XX XXX XXX',
								false)
						}
					</Grid>
				</Grid>		
				<Grid container item direction="row" className={classes.formRow}>
					{this.textField(
							'usageInfo',
							this.state.values.usageInfo,
							localize('contact-sales-form-usage-info'),
							false,
							'textarea',
							null,
							true
					)}
				</Grid>
			</Fragment>
		);
	}

	isSubmitEnabled() {
		let nrOfRequiredFieldsChanged = 0;

		detectErrorsInFormFields.forEach(fieldName => {
			if (this.state.touched[fieldName]) {
				nrOfRequiredFieldsChanged++;
			}
		});

		const allRequiredFieldsChanged = nrOfRequiredFieldsChanged === detectErrorsInFormFields.length;

		// check for input error
		return allRequiredFieldsChanged > 0 && !this.hasFormError(this.state.errors) ||
		Object.keys(this.state.errors).length === 1 && _.get(this.state, 'errors.apiError');
	}

	hasFormError(errorState) {
		let result = false;

		Object.keys(errorState).forEach(fieldName => {
			if (detectErrorsInFormFields.includes(fieldName)) {
				result = true;
			}
		});

		return result;
	}

	componentDidMount() {
		trackContactSalesPopupShown(getTrackingOptions(this.props.company));
	}

	componentWillReceiveProps(nextProps) {
		if (
			this.props.companies.contactSalesErrorId !== nextProps.companies.contactSalesErrorId &&
			nextProps.companies.contactSalesErrorId !== null
		) {
			this.handleApiErrors(nextProps);
		}

		if (this.props.companies.contactSalesSuccess 
			!== nextProps.companies.contactSalesSuccess &&
			nextProps.companies.contactSalesSuccess === true
		) {
			this.setState({
				xhrInProgress: false,
				apiRequestError: false,
				apiRequestSuccess: true,
				errors: { apiError: null }
			});			
		}		
	}

	handleApiErrors(nextProps) {
		if (nextProps.companies.contactSalesErrorId) {
			const errorMessage = nextProps.companies.contactSalesErrorId &&
				errors[nextProps.companies.contactSalesErrorId] || 
				localize('contact-sales-error-unknown');

			this.setState({
				xhrInProgress: false,
				apiRequestError: true,
				apiRequestSuccess: false,
				errors: { apiError: errorMessage }
			});
		}
	}	

	textField(name, value, label, disabled, type, maxLength, autosize, placeholder, required = true) {
		const { classes } = this.props;

		return (
			<Fragment>
				{name !== 'phoneNumber' && (
					<FormLabel required={required} className={classes.formLabel}>
						{label}
					</FormLabel>
				)}
				<FormField
					value={value}
					autoComplete={isChrome ? 'disabled' : 'off'}
					className={
						classNames({
							[classes.fieldTextElement]: true,
							['noLabel']: name === 'phoneNumber'
						})					
					}			
					data-tid={`form-sales-${name}`}
					onChange={event => this.onTextFieldChange(event, name)}
					onBlur={event => this.onTextFieldBlur(event, name)}
					onKeyPress={event => this.onKeyPress(event, name)}
					placeholder={placeholder}
					id={name}
					{...(type ? { type } : {})}
					{...(autosize ? { autosize } : {})}
					margin="normal"
					helperText={this.state.errors[name]}
					error={!!this.state.errors[name]}
					disabled={disabled}
					maxLength={maxLength}
					inputRef={this[name]}
				/>
			</Fragment>
		);
	}

	selectField(name, value, label, required) {
		const { classes } = this.props;
		const hasError = Boolean(this.state.errors[name]);
		return (
			<Fragment>
				<FormLabel required={required} className={classes.formLabel}>
					{label}
				</FormLabel>			
				<Select
					id={name}
					data-tid={name}
					name={name}
					onChange={(event) => this.onSelectFieldChange(event, name)}
					className={classes.fieldSelectElement}
					disableUnderline
					fullWidth
					classes={
						{
							select: hasError ?
								classes.selectElementError
								:
								classes.selectElement, 
							icon: classes.selectElementIcon
						}
					}
					MenuProps={{
						classes: {
							paper: classes.selectElementPaper
						}
					}}		
					displayEmpty
					IconComponent={SelectArrow}
					value={value}
				>
					<MenuItem value="" disabled>
						{(name === 'nrOfUsers' ? localize('contact-sales-form-number-of-users-select'): '+')}
					</MenuItem>
					{name === 'nrOfUsers' ? this.renderNrOfUsersDropdown() : this.renderPhonePrefixDropdown()}
				</Select>
				{hasError && (
					<FormHelperText className={classes.selectError}>{this.state.errors[name]}</FormHelperText>
				)}
			</Fragment>
		);
	}

	renderNrOfUsersDropdown() {
		const { classes } = this.props;

		return (
			NR_OF_USERS_OPTIONS.map((value, index) => (
				<MenuItem key={index} value={value} className={classes.selectElementItem}>
					{value}
				</MenuItem>
			))
		);
	}

	renderPhonePrefixDropdown() {
		/* eslint-disable max-len */
		const { classes } = this.props;

		const COUNTRY_OPTIONS = [
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-af'} value="+93" data-value="AF">Afghanistan (+93)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-al'} value="+355" data-value="AL">Albania (+355)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-dz'} value="+213" data-value="DZ">Algeria (+213)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ad'} value="+376" data-value="AD">Andorra (+376)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ao'} value="+244" data-value="AO">Angola (+244)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-aq'} value="+672" data-value="AQ">Antarctica (+672)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ag'} value="+1" data-value="AG">Antigua and Barbuda (+1-268)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ar'} value="+54" data-value="AR">Argentina (+54)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-am'} value="+374" data-value="AM">Armenia (+374)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-aw'} value="+297" data-value="AW">Aruba (+297)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ac'} value="+247" data-value="AC">Ascension Island (+247)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-au'} value="+61" data-value="AU">Australia (+61)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-at'} value="+43" data-value="AT">Austria (+43)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-az'} value="+994" data-value="AZ">Azerbaijan (+994)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bs'} value="+1" data-value="BS">Bahamas (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bh'} value="+973" data-value="BH">Bahrain (+973)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bd'} value="+880" data-value="BD">Bangladesh (+880)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bb'} value="+1" data-value="BB">Barbados (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-by'} value="+375" data-value="BY">Belarus (+375)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-be'} value="+32" data-value="BE">Belgium (+32)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bz'} value="+501" data-value="BZ">Belize (+501)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bj'} value="+229" data-value="BJ">Benin (+229)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bm'} value="+1" data-value="BM">Bermuda (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bt'} value="+975" data-value="BT">Bhutan (+975)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bo'} value="+591" data-value="BO">Bolivia (+591)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bq'} value="+599" data-value="BQ">Bonaire (+599)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ba'} value="+387" data-value="BA">Bosnia and Herzegovina (+387)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bw'} value="+267" data-value="BW">Botswana (+267)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bv'} value="+47" data-value="BV">Bouvet Island (+47)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-br'} value="+55" data-value="BR">Brazil (+55)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-io'} value="+44" data-value="IO">British Indian Ocean Territory (+44)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-vg'} value="+1" data-value="VG">British Virgin Islands (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bn'} value="+673" data-value="BN">Brunei (+673)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bg'} value="+359" data-value="BG">Bulgaria (+359)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bf'} value="+226" data-value="BF">Burkina Faso (+226)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-bi'} value="+257" data-value="BI">Burundi (+257)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cv'} value="+238" data-value="CV">Cabo Verde (+238)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-kh'} value="+855" data-value="KH">Cambodia (+855)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cm'} value="+237" data-value="CM">Cameroon (+237)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ca'} value="+1" data-value="CA">Canada (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ky'} value="+1" data-value="KY">Cayman Islands (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cf'} value="+236" data-value="CF">Central African Republic (+236)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-td'} value="+235" data-value="TD">Chad (+235)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cl'} value="+56" data-value="CL">Chile (+56)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cn'} value="+86" data-value="CN">China (+86)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cx'} value="+61" data-value="CX">Christmas Island (+61)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cc'} value="+61" data-value="CC">Cocos (Keeling) Islands (+61)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-c0'} value="+57" data-value="CO">Colombia (+57)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-km'} value="+269" data-value="KM">Comoros (+269)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cg'} value="+242" data-value="CG">Congo (+242)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cd'} value="+243" data-value="CD">Congo (DRC) (+243)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ck'} value="+682" data-value="CK">Cook Islands (+682)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cr'} value="+506" data-value="CR">Costa Rica (+506)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ci'} value="+225" data-value="CI">C&#244;te d&#39;Ivoire (+225)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-hr'} value="+385" data-value="HR">Croatia (+385)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cu'} value="+53" data-value="CU">Cuba (+53)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cw'} value="+599" data-value="CW">Curaçao (+599)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cy'} value="+357" data-value="CY">Cyprus (+357)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-cz'} value="+420" data-value="CZ">Czechia (+420)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-dk'} value="+45" data-value="DK">Denmark (+45)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-dj'} value="+253" data-value="DJ">Djibouti (+253)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-dm'} value="+1" data-value="DM">Dominica (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-do'} value="+1" data-value="DO">Dominican Republic (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ec'} value="+593" data-value="EC">Ecuador (+593)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-eg'} value="+20" data-value="EG">Egypt (+20)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sv'} value="+503" data-value="SV">El Salvador (+503)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gq'} value="+240" data-value="GQ">Equatorial Guinea (+240)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-er'} value="+291" data-value="ER">Eritrea (+291)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ee'} value="+372" data-value="EE">Estonia (+372)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-et'} value="+251" data-value="ET">Ethiopia (+251)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-fk'} value="+500" data-value="FK">Falkland Islands (+500)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-fo'} value="+298" data-value="FO">Faroe Islands (+298)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-fj'} value="+679" data-value="FJ">Fiji (+679)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-fi'} value="+358" data-value="FI">Finland (+358)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-fr'} value="+33" data-value="FR">France (+33)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gf'} value="+594" data-value="GF">French Guiana (+594)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-pf'} value="+689" data-value="PF">French Polynesia (+689)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ga'} value="+241" data-value="GA">Gabon (+241)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gm'} value="+220" data-value="GM">Gambia (+220)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ge'} value="+995" data-value="GE">Georgia (+995)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-de'} value="+49" data-value="DE">Germany (+49)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gh'} value="+233" data-value="GH">Ghana (+233)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gi'} value="+350" data-value="GI">Gibraltar (+350)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gr'} value="+30" data-value="GR">Greece (+30)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gl'} value="+299" data-value="GL">Greenland (+299)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gd'} value="+1" data-value="GD">Grenada (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gp'} value="+590" data-value="GP">Guadeloupe (+590)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gu'} value="+1" data-value="GU">Guam (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gt'} value="+502" data-value="GT">Guatemala (+502)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gg'} value="+44" data-value="GG">Guernsey (+44)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gn'} value="+224" data-value="GN">Guinea (+224)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gw'} value="+245" data-value="GW">Guinea-Bissau (+245)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-gy'} value="+592" data-value="GY">Guyana (+592)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ht'} value="+509" data-value="HT">Haiti (+509)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-hn'} value="+504" data-value="HN">Honduras (+504)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-hk'} value="+852" data-value="HK">Hong Kong SAR (+852)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-hu'} value="+36" data-value="HU">Hungary (+36)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-is'} value="+354" data-value="IS">Iceland (+354)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-in'} value="+91" data-value="IN">India (+91)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-id'} value="+62" data-value="ID">Indonesia (+62)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ir'} value="+98" data-value="IR">Iran (+98)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-iq'} value="+964" data-value="IQ">Iraq (+964)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ie'} value="+353" data-value="IE">Ireland (+353)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-im'} value="+44" data-value="IM">Isle of Man (+44)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-il'} value="+972" data-value="IL">Israel (+972)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-it'} value="+39" data-value="IT">Italy (+39)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-jm'} value="+1" data-value="JM">Jamaica (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-xj'} value="+47" data-value="XJ">Jan Mayen (+47)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-jp'} value="+81" data-value="JP">Japan (+81)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-je'} value="+44" data-value="JE">Jersey (+44)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-jo'} value="+962" data-value="JO">Jordan (+962)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-kz'} value="+7" data-value="KZ">Kazakhstan (+7)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ke'} value="+254" data-value="KE">Kenya (+254)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ki'} value="+686" data-value="KI">Kiribati (+686)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-kr'} value="+82" data-value="KR">Korea (+82)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-xk'} value="+383" data-value="XK">Kosovo (+383)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-kw'} value="+965" data-value="KW">Kuwait (+965)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-kg'} value="+996" data-value="KG">Kyrgyzstan (+996)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-la'} value="+856" data-value="LA">Laos (+856)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-lv'} value="+371" data-value="LV">Latvia (+371)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-lb'} value="+961" data-value="LB">Lebanon (+961)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ls'} value="+266" data-value="LS">Lesotho (+266)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-lr'} value="+231" data-value="LR">Liberia (+231)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ly'} value="+218" data-value="LY">Libya (+218)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-li'} value="+423" data-value="LI">Liechtenstein (+423)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-lt'} value="+370" data-value="LT">Lithuania (+370)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-lu'} value="+352" data-value="LU">Luxembourg (+352)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mo'} value="+853" data-value="MO">Macao SAR (+853)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mg'} value="+261" data-value="MG">Madagascar (+261)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mw'} value="+265" data-value="MW">Malawi (+265)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-my'} value="+60" data-value="MY">Malaysia (+60)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mv'} value="+960" data-value="MV">Maldives (+960)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ml'} value="+223" data-value="ML">Mali (+223)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mt'} value="+356" data-value="MT">Malta (+356)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mh'} value="+692" data-value="MH">Marshall Islands (+692)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mq'} value="+596" data-value="MQ">Martinique (+596)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mr'} value="+222" data-value="MR">Mauritania (+222)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mu'} value="+230" data-value="MU">Mauritius (+230)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-yt'} value="+262" data-value="YT">Mayotte (+262)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mx'} value="+52" data-value="MX">Mexico (+52)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-fm'} value="+691" data-value="FM">Micronesia (+691)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-md'} value="+373" data-value="MD">Moldova (+373)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mc'} value="+377" data-value="MC">Monaco (+377)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mn'} value="+976" data-value="MN">Mongolia (+976)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-me'} value="+382" data-value="ME">Montenegro (+382)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ms'} value="+1" data-value="MS">Montserrat (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ma'} value="+212" data-value="MA">Morocco (+212)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mz'} value="+258" data-value="MZ">Mozambique (+258)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mm'} value="+95" data-value="MM">Myanmar (+95)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-na'} value="+264" data-value="NA">Namibia (+264)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-nr'} value="+674" data-value="NR">Nauru (+674)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-np'} value="+977" data-value="NP">Nepal (+977)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-nl'} value="+31" data-value="NL">Netherlands (+31)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-an'} value="+599" data-value="AN">Netherlands Antilles (Former) (+599)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-nc'} value="+687" data-value="NC">New Caledonia (+687)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-nz'} value="+64" data-value="NZ">New Zealand (+64)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ni'} value="+505" data-value="NI">Nicaragua (+505)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ne'} value="+227" data-value="NE">Niger (+227)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ng'} value="+234" data-value="NG">Nigeria (+234)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-nu'} value="+683" data-value="NU">Niue (+683)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-kp'} value="+850" data-value="KP">North Korea (+850)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mk'} value="+389" data-value="MK">North Macedonia (+389)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-mp'} value="+1" data-value="MP">Northern Mariana Islands (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-no'} value="+47" data-value="NO">Norway (+47)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-om'} value="+968" data-value="OM">Oman (+968)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-pk'} value="+92" data-value="PK">Pakistan (+92)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-pw'} value="+680" data-value="PW">Palau (+680)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ps'} value="+970" data-value="PS">Palestinian Authority (+970)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-pa'} value="+507" data-value="PA">Panama (+507)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-pg'} value="+675" data-value="PG">Papua New Guinea (+675)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-py'} value="+595" data-value="PY">Paraguay (+595)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-pe'} value="+51" data-value="PE">Peru (+51)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ph'} value="+63" data-value="PH">Philippines (+63)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-pl'} value="+48" data-value="PL">Poland (+48)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-pt'} value="+351" data-value="PT">Portugal (+351)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-qa'} value="+974" data-value="QA">Qatar (+974)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-re'} value="+262" data-value="RE">Réunion (+262)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ro'} value="+40" data-value="RO">Romania (+40)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ru'} value="+7" data-value="RU">Russia (+7)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-rw'} value="+250" data-value="RW">Rwanda (+250)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-xs'} value="+599" data-value="XS">Saba (+599)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-kn'} value="+1" data-value="KN">Saint Kitts and Nevis (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-lc'} value="+1" data-value="LC">Saint Lucia (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-pm'} value="+508" data-value="PM">Saint Pierre and Miquelon (+508)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-vc'} value="+1" data-value="VC">Saint Vincent and the Grenadines (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ws'} value="+685" data-value="WS">Samoa (+685)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sm'} value="+378" data-value="SM">San Marino (+378)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-st'} value="+239" data-value="ST">São Tomé and Príncipe (+239)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sa'} value="+966" data-value="SA">Saudi Arabia (+966)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sn'} value="+221" data-value="SN">Senegal (+221)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-rs'} value="+381" data-value="RS">Serbia (+381)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sc'} value="+248" data-value="SC">Seychelles (+248)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sl'} value="+232" data-value="SL">Sierra Leone (+232)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sg'} value="+65" data-value="SG">Singapore (+65)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-xe'} value="+599" data-value="XE">Sint Eustatius (+599)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sk'} value="+421" data-value="SK">Slovakia (+421)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-si'} value="+386" data-value="SI">Slovenia (+386)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sb'} value="+677" data-value="SB">Solomon Islands (+677)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-so'} value="+252" data-value="SO">Somalia (+252)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-za'} value="+27" data-value="ZA">South Africa (+27)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ss'} value="+211" data-value="SS">South Sudan (+211)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-es'} value="+34" data-value="ES">Spain (+34)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-lk'} value="+94" data-value="LK">Sri Lanka (+94)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sh'} value="+290" data-value="SH">St Helena, Ascension, and Tristan da Cunha (+290)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sd'} value="+249" data-value="SD">Sudan (+249)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sr'} value="+597" data-value="SR">Suriname (+597)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sj'} value="+47" data-value="SJ">Svalbard (+47)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sz'} value="+268" data-value="SZ">Swaziland (+268)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-se'} value="+46" data-value="SE">Sweden (+46)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ch'} value="+41" data-value="CH">Switzerland (+41)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-sy'} value="+963" data-value="SY">Syria (+963)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-tw'} value="+886" data-value="TW">Taiwan (+886)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-tj'} value="+992" data-value="TJ">Tajikistan (+992)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-tz'} value="+255" data-value="TZ">Tanzania (+255)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-th'} value="+66" data-value="TH">Thailand (+66)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-tl'} value="+670" data-value="TL">Timor-Leste (+670)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-tg'} value="+228" data-value="TG">Togo (+228)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-tk'} value="+690" data-value="TK">Tokelau (+690)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-to'} value="+676" data-value="TO">Tonga (+676)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-tt'} value="+1" data-value="TT">Trinidad and Tobago (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ta'} value="+290" data-value="TA">Tristan da Cunha (+290)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-tn'} value="+216" data-value="TN">Tunisia (+216)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-tr'} value="+90" data-value="TR">Turkey (+90)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-tm'} value="+993" data-value="TM">Turkmenistan (+993)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-tc'} value="+1" data-value="TC">Turks and Caicos Islands (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-tv'} value="+688" data-value="TV">Tuvalu (+688)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-um'} value="+1" data-value="UM">U.S. Outlying Islands (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-vi'} value="+1" data-value="VI">U.S. Virgin Islands (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ug'} value="+256" data-value="UG">Uganda (+256)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ua'} value="+380" data-value="UA">Ukraine (+380)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ae'} value="+971" data-value="AE">United Arab Emirates (+971)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-uk'} value="+44" data-value="UK">United Kingdom (+44)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-us'} value="+1" data-value="US">United States (+1)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-uy'} value="+598" data-value="UY">Uruguay (+598)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-uz'} value="+998" data-value="UZ">Uzbekistan (+998)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-vu'} value="+678" data-value="VU">Vanuatu (+678)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-va'} value="+379" data-value="VA">Vatican City (+379)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ve'} value="+58" data-value="VE">Venezuela (+58)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-vn'} value="+84" data-value="VN">Vietnam (+84)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-wf'} value="+681" data-value="WF">Wallis and Futuna (+681)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-ye'} value="+967" data-value="YE">Yemen (+967)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-zm'} value="+260" data-value="ZM">Zambia (+260)</MenuItem>,
			<MenuItem className={classes.selectElementItem} key={'phone-prefix-zw'} value="+263" data-value="ZW">Zimbabwe (+263)</MenuItem>,			
		];
		
		return (
			COUNTRY_OPTIONS.map(el => el)
		);
	}
					
	onTextFieldChange(event, name) {
		this.setFieldState(name, event.target.value);
	}

	validateAll() {
		let errors = {};
		for (let field in ValidationSchema) {
			let validate = ValidationSchema[field];
			if (validate) {
				let error = validate(this.state.values[field], this.state, this.props);
				if (error) {
					errors[field] = error;
				}
			}
		}
		this.setState({ errors });
	}

	onTextFieldBlur(event, name) {
		let newState = _.cloneDeep(this.state);
		newState.touched[name] = true;
		this.setState(newState, this.validateAll);
	}	

	onSelectFieldChange(event, name) {
		this.setFieldState(name, event.target.value);
	}	

	setFieldState(fieldName, value) {
		let newState = _.cloneDeep(this.state);
		newState.touched[fieldName] = true;
		newState.values = {
			...(newState.values || {}),
			[fieldName]: value
		};
		this.setState(newState, this.validateAll);
	}

	onKeyPress(event, name) {
		if (!this.isSubmitEnabled() || name === 'usageInfo') return;
		if (event.key === 'Enter') {
			this.submitForm();
		}
	}

	submitForm() {
		this.setState({ 
			xhrInProgress: true,
			apiRequestError: false,
			apiRequestSuccess: false,
			errors: { apiError: null }
		});

		this.props.sendContactSalesRequest(
			{
				companyId: this.props.selectedCompanyId,
				'user-xc-id': _.get(this.props.user, 'userId'),
				sessionEmail: _.get(this.props.user, 'mainEmail'),
				'process-sales-form': 1,
				lang: i18n.getCurrentLanguage(),
				...this.state.values
			});
	}
}

ContactSalesModal.propTypes = {
	companies: PropTypes.object,
	modalShown: PropTypes.bool,
	hideModal: PropTypes.func,
	resetModal: PropTypes.func,
	selectedCompanyId: PropTypes.string,
	classes: PropTypes.object,
	sendContactSalesRequest: PropTypes.func,
	user: PropTypes.object.isRequired,
	title: PropTypes.string,
	company: PropTypes.object,
};

const mapStateToProps = state => ({
	company: state.companies.rawDataById ? state.companies.rawDataById[state.companies.selectedId] : null,
	selectedCompanyId: state.companies.selectedId,
	modalShown: state.modal.modalShown,
	companies: state.companies,
	user: state.session.user
});

const mapDispatchToProps = dispatch => bindActionCreators({
	sendContactSalesRequest,
	hideModal,
	resetModal,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(ContactSalesModal);


// WEBPACK FOOTER //
// ./src/components/Modal/ContactSalesModal.js